module.exports = __webpack_public_path__ + "img/gasbot_smile.003dff88.png";